import un from 'underscore'
import alertify from 'alertifyjs'
import moment from 'moment'

const activeStatusVal = "ACTIVE"
const endOkStatusVal = "FINISHED_OK"
const endBadStatusVal = "FINISHED_BAD"

function determineText(days) {
    if (days === 1) {
        return `${days} dzień`
    } else {
        return `${days} dni`
    }
}

function itemCounterInfo(item) {
    if (item.status === endOkStatusVal) {
        return `<span>Zakończona pozytywnie</span>`;
    }
    if (item.status === endBadStatusVal) {
      return `<span>Zakończona negatywnie</span>`;
    }
    let text = determineText(item.counterInfo.days)
    if (item.counterInfo.exceed) {
        return `<span>Przekroczono ${text}</span>`
    } else {
        if (item.counterInfo.days === 0) {
            return `<span>Dzisiaj</span>`
        } else {
            return `<span>Za ${text}</span>`
        }
    }
}

function determineSearchValue(value) {
    return value.length > 1 ? value : ""
}

function anyItemToSearch(data) {
    return un.some(data, item => {
        return item.length > 0
    })
}

function allItemsEmpty(data) {
    return un.every(data, item => {
        return item.length === 0
    })
}

function prepareSearch(search) {
    return {
        productName: determineSearchValue(search.productName),
        contactPhone: determineSearchValue(search.contactPhone),
    }
}

function canSearch(search) {
    let data = prepareSearch(search)
    return allItemsEmpty(data) ? true : anyItemToSearch(data)
}

function availableStatuses() {
    return [
        {
            text: "Aktywna",
            id: activeStatusVal
        },
        {
          text: "Zakończona pozytywnie",
          id: endOkStatusVal
        },
        {
          text: "Zakończona negatywnie",
          id: endBadStatusVal
        }
    ]
}

function availableStatusesForSearch() {
    return [
        {
            text: "Aktywne",
            id: activeStatusVal
        },
        {
            text: "Zakończone pozytywnie",
            id: endOkStatusVal
        },
        {
          text: "Zakończone negatywnie",
          id: endBadStatusVal
        }
    ]
}

function determineClass(item) {
    if (item.status !== activeStatusVal) {
        return ""
    }
    if (item.counterInfo.exceed) {
        return "red-font"
    } else if (item.counterInfo.days === 0 || item.counterInfo.days === 1) {
        return "red-font"
    }
    return ""
}

function notifyUser(action, productName) {
    const msg = `${action} reklamację ${productName}`
    alertify.set('notifier','position', 'top-center');
    alertify.success(msg).delay(3);
}

function notifyUserWithMessage(msg) {
    alertify.set('notifier','position', 'top-center');
    alertify.success(msg).delay(3);
}

function showPrompt(productName, callback) {
    alertify.confirm('', productName, function(){
        callback()
        }, function(){},
    );
}

function createHistoryItem() {
    return {
        "description": "",
        "createdAt": moment().format("YYYY-MM-DD")
    }
}

function removeHistoryItem(historyItems, id) {
    return un.without(historyItems, un.findWhere(historyItems, { id: id }));
}

function prepareFormData(form) {
    var newForm = JSON.parse(JSON.stringify(form));
    newForm.createdAt = moment(newForm.createdAt).format("YYYY-MM-DD")
    for (var i in newForm.historyItems) {
        var item = newForm.historyItems[i]
        item.createdAt = moment(item.createdAt).format("YYYY-MM-DD")
    }
    return newForm
}

export default {
    "itemCounterInfo": itemCounterInfo,
    "canSearch": canSearch,
    "prepareSearch": prepareSearch,
    "availableStatuses": availableStatuses,
    "availableStatusesForSearch": availableStatusesForSearch,
    "determineClass": determineClass,
    "notifyUser": notifyUser,
    "showPrompt": showPrompt,
    "createHistoryItem": createHistoryItem,
    "prepareFormData": prepareFormData,
    "removeHistoryItem": removeHistoryItem,
    "notifyUserWithMessage": notifyUserWithMessage
}



// WEBPACK FOOTER //
// ./src/components/complaints/ComplaintsService.js